import { createProductFormState } from "@/controllers/productFormState";
import productFormComputed from "@/controllers/productFormComputed";
import productFormLifecycle from "@/controllers/productFormLifecycle";
import productFormDataMethods from "@/controllers/productFormDataMethods";
import productFormFileMethods from "@/controllers/productFormFileMethods";
import productFormInputMethods from "@/controllers/productFormInputMethods";
import productFormPersistenceMethods from "@/controllers/productFormPersistenceMethods";

export default {
  data() {
    return createProductFormState();
  },
  computed: productFormComputed,
  ...productFormLifecycle,
  methods: {
    ...productFormDataMethods,
    ...productFormFileMethods,
    ...productFormInputMethods,
    ...productFormPersistenceMethods,
  },
};
